export default __webpack_public_path__ + "static/media/Skranji-Bold.0a9101ec.ttf";